import React, { ReactElement, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface IProps {
  children: ReactElement;
}

const Portal = (props: IProps) => {
  const { children } = props;
  const [mounted, setMounted] = useState<boolean>(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (typeof window === 'undefined') return <></>;
  const portalContainer = document.getElementById('__next');
  if (!portalContainer || !mounted) return null;

  return createPortal(children, portalContainer);
};

export default Portal;
